import mock from "@/fake-db/mock.js"
import jwt from 'jsonwebtoken'
import axios from "../../../http/axios/index.js"
import store from "../../../store/store"
const data = {
  checkpointReward: {
    userName: "John",
    progress: "57.6%"
  },
  infos: [
  ],
  condidats:[],
  formateurs:[],
  users: [{
    /*uid:'',
    email:'',
    password:'',
    avatar:'',*/
  }
  ]
}
// console.log("store",store)
// axios.get("https://trainingcenterback.codily.net/api/getadmin").then(resp => {
//     const ddta = resp.data
//     data.users = ddta
    
//     console.log(resp.data);
//     console.log(ddta);
//     console.log(data.infos);
//     console.log(data.users);
//     //const info = data.infos.find(info => info.email === resp.data[0].email && info.password === resp.data[0].password)
//     //console.log(info)
// });
const jwtConfig = {
    "secret"   : "dd5f3089-40c3-403d-af14-d0c228b05cb4",
    "expireTime": 8000
}
// axios.get("https://trainingcenterback.codily.net/api/getformateur").then(resp => {
//     const ddta = resp.data
//     data.formateurs = ddta
    
//     console.log(resp.data);
//     console.log(ddta);
//     console.log(data.infos);
//     console.log('formateurs',data.formateurs);
//     //const info = data.infos.find(info => info.email === resp.data[0].email && info.password === resp.data[0].password)
//     //console.log(info)
// });
// axios.get("https://trainingcenterback.codily.net/api/getCandidat").then(resp => {
//     const ddta = resp.data
//     data.candidats = ddta
    
//     console.log(resp.data);
//     console.log(ddta);
//     console.log(data.infos);
//     console.log('candidat',data.candidats);
    
// });
//loginCandidat
mock.onPost("/api/auth/loginCandidat").reply((request) => {
  const {email, password} = JSON.parse(request.data)
  console.log('11010',axios.post("https://trainingcenterback.codily.net/api/getCandidatlogin", {email: email, password: password}))
  return axios.post("https://trainingcenterback.codily.net/api/getCandidatlogin", {email: email, password: password})
  // let error = "Something went wrong"
  // console.log("13",data.users.email);
  // console.log("13");
  // const user = data.candidats.find(user => email === user.email  & user.password === password)
  // console.log('user',user);
  /*
  console.log(user.email);
  console.log(email);
  console.log(password);*/
  
  // if (user) {

  //   try {

  //     // const accessToken = jwt.sign({id: user.uid}, "dd5f3089-40c3-403d-af14-d0c228b05cb4", {expiresIn: 8000})

  //     const userData = Object.assign({}, user, {providerId: "jwt"})

  //     const response = {
  //       userData : userData,
  //       accessToken: accessToken
  //     }
  //     console.log('response',response)
  //     return [200, response]

  //   } catch(e) {
  //     error = e
  //   }
  // }else {
  //   error = "Email Or Password Invalid"
  // }

  // return [200, "Email Or Password Invalid"]


})
mock.onPost("/api/auth/loginFormateur").reply((request) => {
  const {email, password} = JSON.parse(request.data)

  // let error = "Something went wrong"
  // console.log("12",data.users.email);
  // console.log("12");
  // const user = data.formateurs.find(user => email === user.email  & user.password === password)
  // console.log('user',user);/*
  // console.log(user.email);
  // console.log(email);
  // console.log(password);*/
  // if (user) {

  //   try {

  //     const accessToken = jwt.sign({id: user.uid}, jwtConfig.secret, {expiresIn: jwtConfig.expireTime})

  //     const userData = Object.assign({}, user, {providerId: "jwt"})

  //     const response = {
  //       userData : userData,
  //       accessToken: accessToken
  //     }
  //     console.log('response',response)
  //     return [200, response]

  //   } catch(e) {
  //     error = e
  //   }
  // }else {
  //   error = "Email Or Password Invalid"
  // }

  // return [200, {error}]
  // console.log(axios.post("https://trainingcenterback.codily.net/api/getFormateurlogin", {email: email, password: password}))
  return axios.post("https://trainingcenterback.codily.net/api/getFormateurlogin", {email: email, password: password})

})
mock.onPost("/api/auth/login").reply((request) => {
  const {email, password} = JSON.parse(request.data)

  // let error = "Something went wrong"
  
  // const user = data.users.find(user => email === user.email  & user.password === password)
  
  // if (user) {

  //   try {

  //     const accessToken = jwt.sign({id: user.uid}, jwtConfig.secret, {expiresIn: jwtConfig.expireTime})

  //     const userData = Object.assign({}, user, {providerId: "jwt"})

  //     const response = {
  //       userData : userData,
  //       accessToken: accessToken
  //     }
  //     console.log('response',response)
  //     return [200, response]

  //   } catch(e) {
  //     error = e
  //   }
  // }else {
  //   error = "Email Or Password Invalid"
  // }

  // return [200, {error}]
  
  // console.log(axios.post("https://trainingcenterback.codily.net/api/getadmin", {email: email, password: password}))
  return axios.post("https://trainingcenterback.codily.net/api/getadmin", {email: email, password: password})

})

mock.onPost('/api/auth/register').reply((request) => {
    const {displayName, email, password} = JSON.parse(request.data)
    const isEmailAlreadyInUse = data.users.find((user) => user.email === email)
    const error = {
      email      : isEmailAlreadyInUse ? 'This email is already in use.' : null,
      displayName: displayName === '' ? 'Please enter your name.' : null
    }

    if ( !error.displayName && !error.email ) {

      let userData = {
        email: email,
        password: password,
        nom: displayName,
        avatar: require("@/assets/images/portrait/small/avatar-s-5.jpg"),
        phoneNumber: null
      }

      // Add user id
      const length = data.users.length
      let lastIndex = 0
      if(length){
        lastIndex = data.users[length - 1].uid
      }
      userData.uid = lastIndex + 1

      data.users.push(userData)
      console.log(data.users);

      const accessToken = jwt.sign({id: userData.uid}, jwtConfig.secret, {expiresIn: jwtConfig.expireTime})

      let user = Object.assign({}, userData)
      //delete user['password']
      const response = { userData: user, accessToken: accessToken }
      console.log("11",user);

      axios.post("https://trainingcenterback.codily.net/api/addadmin", {
        nom: user.displayName,
        email: user.email,
        password: user.password,

      } )
      .then(function (response) {
        console.log("12345678",response);
      })
      return [200, response]
    } else {
      return [200, {error}]
    }
})


/*const FormData = require('form-data');
const fs = require('fs');

formData.append("nom", this.namemenu);
formData.append("prix", this.prixmenu);
const res = await axios.post('http://localhost:3000/upload', formData, {
  // You need to use `getHeaders()` in Node.js because Axios doesn't
  // automatically set the multipart form boundary in Node.
  headers: formData.getHeaders()
});*/

mock.onPost('/api/auth/refresh-token').reply((request) => {

  const {accessToken} = JSON.parse(request.data)
  
  try {
    const {id} = jwt.verify(accessToken, jwtConfig.secret)

    let userData = Object.assign({}, data.users.find(user => user.uid === id))

    const newAccessToken = jwt.sign({id: userData.uid}, jwtConfig.secret, {expiresIn: jwtConfig.expiresIn});

    delete userData['password']
    const response = {
      userData: userData,
      accessToken: newAccessToken
    }
    console.log("userData",userData)
    return [200, response]
  } catch (e){
    const error = "Invalid access token"
    return [401, {error}]
  }
})


mock.onGet("/api/user/checkpoint-reward").reply(() => {
  return [200, data.checkpointReward];
});
console.log("localStorage",localStorage)
const userInfoLocalStorage = JSON.parse(localStorage.getItem("userInfo")) || {}
console.log("userInfoLocalStorage",userInfoLocalStorage)
// Set default values for active-user
// More data can be added by auth provider or other plugins/packages
